// link
import { Link, useLocation, useNavigate } from "react-router";
// style
import './style/header.css'
// routes
import { RoutesClient } from "../../features/routes/routes";
// icon
import { IconPhoneCall, IconShoppingBag, IconUser, IconUserCircle, IconX } from "@tabler/icons-react";
// hook
import { useEffect, useState } from "react";
// mobile nav
import MobileNav from "../../components/mobileNav/mobileNav";
import HeaderNav from "../../components/headerNav/headerNav";
// controller
import useGetData from "../../hook/getData";
import { GetCategories } from "../../services/client/categories/getCategories";
// @ts-ignore
import Cookies from "js-cookie";
// context 
import { useCart } from "../../context/cartContext";
import { GetCarts } from "../../services/panel/cart/getCart";
import ModalSearch from "../../components/modal/search";
import CategoryModal from "../../components/modal/category";
import CategoryCollapse from "../../components/modal/categoryModal";
import OffCanvas from "../../components/mobileNav/offcanvas";
const DetailHeader = () => {
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
    const [parentCategory, setParentCategory] = useState<any>();
    const [categoryId, setCategoryId] = useState<any>();
    const [childCategory, setChildCategory] = useState<any>();
    const { data: carts } = useGetData(['carts'], GetCarts)
    const closeMenu = () => {
        setIsMenuOpen(false);
    };
    const { data: categoires } = useGetData(['categories'], GetCategories)
    const location = useLocation();
    useEffect(() => {
        setIsMenuOpen(false);
    }, [location.pathname]);
    useEffect(() => {
        let parents = categoires?.filter((category: any) => Number(category.parent_id) === 0)
        let childs = categoires?.filter((Category: any) => Number(Category.parent_id) !== 0)
        setParentCategory(parents);
        setChildCategory(childs);
        document.getElementById('pages-header')?.classList.remove('d-none');
    }, [categoires])
    const navigate = useNavigate();
    const handleNavigate = (slug: string) => {
        navigate(`/categories/${slug}`);
        const closeModalButton: any = document.getElementById("close-modal");
        if (closeModalButton) {
            closeModalButton.click();
        }
    };
    const { cart } = useCart();
    const cartCount = cart.length;
    return (
        <>
            <header id="pages-header" className="position-sticky bg-white pages-header" onMouseLeave={() => closeMenu()}>
                <div className="container py-3 pb-2">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-3">
                            <IconX className="d-inline-block d-md-none" onClick={() => window.history.back()} />
                            <Link className="navbar-brand d-md-inline-block d-none" to="/">
                                <img alt="logo" src={require('./../../assets/media/logo/logo_new.png')} className="logo-img-new" />
                            </Link>
                        </div>
                        <div className="col-md-4 d-md-inline-block d-none  position-relative">
                            <input data-bs-toggle="modal" data-bs-target="#modal-search" placeholder="به دنبال چه چیزی می گردید؟" className="form-control font-medium-lg rounded rounded-5 ms-2 py-2"></input>
                        </div>
                        <div className="col-md-3 col-6">
                            <div className="d-flex justify-content-end align-items-center gx-4">
                                {Cookies.get('agent_token') ? (
                                    <>
                                        <Link to={'/user/profile'} className="text-black">
                                            <IconUserCircle size={25} />
                                        </Link>
                                    </>
                                ) : (
                                    <IconUser className="text-black" data-bs-toggle="modal" data-bs-target="#agent" />
                                )}
                                <Link to={'/cart'} className="text-black position-relative mx-3 me-0">
                                    <IconShoppingBag size={25} />
                                    <span className="position-absolute top-0 font-small start-0 translate-middle badge rounded-pill bg-secondary">{carts?.cartItems?.length ? carts.cartItems.length : cartCount}</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <nav className="navbar bg-white navbar-expand-md py-0">
                    <section className="container">
                        <div className="collapse navbar-collapse justify-content-between align-items-center" id="navbarSupportedContent">
                            <ul className="navbar-nav me-auto font-medium-lg mb-2 mb-lg-0">
                                <li className="nav-item">
                                    <span data-bs-toggle="collapse" onMouseOver={() => setIsMenuOpen(true)} className="nav-link text-black mx-1">
                                        دسته بندی کالا
                                    </span>
                                </li>
                                {RoutesClient.map((address) => (
                                    <>
                                        <HeaderNav child={address.child} show={address.show} key={address.address} label={address.label} address={address.address} />
                                    </>
                                ))}
                            </ul>
                            <div className="actions d-md-inline-block d-none">
                                <div className="d-flex align-items-center gx-4">
                                    <Link to={'#'} className="position-relative font-medium text-black text-decoration-none mx-1 p-2">
                                        <IconPhoneCall size={16} className="me-1" />
                                        09373739843
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </section>
                </nav>
                {isMenuOpen && (
                    <CategoryCollapse childCategory={childCategory} parentCategory={parentCategory} setCategoryId={setCategoryId} categoryId={categoryId} />
                )}
            </header >
            <CategoryModal childCategory={childCategory} parentCategory={parentCategory} handleNavigate={handleNavigate} />
            <ModalSearch />
            <MobileNav routes={RoutesClient} />
            <OffCanvas routes={RoutesClient} />
        </>
    )
}

export default DetailHeader;